import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormulaireAdresseCanada } from './formulaire-coordonnees.model';

import { CustomValidators } from '../../validators/custom-validators.validators';
import { FormulaireCourriel } from './formulaire-courriel.model';
import { FormulaireTelephone } from './formulaire-telephones.model';

export class FormulaireBuilder {
  // Caractères autorisés par la règle RA-ADP0001
  static canada(): FormGroup<FormulaireAdresseCanada> {
    return new FormGroup<FormulaireAdresseCanada>({
      rueCanada: new FormControl<string | null>('', [
        Validators.required,
        Validators.maxLength(30),
        CustomValidators.texteNonBlanc,
        CustomValidators.caracteresValidesBackendSeulement,
        CustomValidators.doitAvoirUneSeparation,
      ]),
      appartementCanada: new FormControl<string | null>('', [
        Validators.maxLength(8),
        CustomValidators.caracteresValidesBackendSeulement,
      ]),
      villeCanada: new FormControl<string | null>('', [
        Validators.required,
        Validators.maxLength(25),
        CustomValidators.texteNonBlanc,
        CustomValidators.ville,
      ]),
      provinceCanada: new FormControl<string | null>('', [Validators.required]),
      codePostalCanada: new FormControl<string | null>('', [
        Validators.required,
        CustomValidators.codePostalCanada,
        CustomValidators.caracteresValidesBackendSeulement,
      ]),
    });
  }

  static courriel(): FormGroup<FormulaireCourriel> {
    return new FormGroup<FormulaireCourriel>({
      courriel: new FormControl<string | null>('', [
        Validators.required,
        Validators.maxLength(50),
        CustomValidators.texteNonBlanc,
        CustomValidators.courrielValide,
      ]),
      cartes: new FormArray([]),
    });
  }
  static telephone(): FormGroup<FormulaireTelephone> {
    return new FormGroup<FormulaireTelephone>({
      principal: new FormControl<string | null>('', [Validators.maxLength(12), CustomValidators.numeroTelephone]),
      secondaire: new FormControl<string | null>('', [Validators.maxLength(12), CustomValidators.numeroTelephone]),
      employeur: new FormControl<string | null>('', [Validators.maxLength(12), CustomValidators.numeroTelephone]),
      numeroPoste: new FormControl<string | null>('', [Validators.maxLength(6), CustomValidators.numeroPoste]),
    });
  }
}
